// One column of the credentials form — Source and Target authenticate fully independently, own
// email and password each (Source's email is resolved from its own linked account, which may
// differ from Target's — see entities-tab.js).
function CredentialsColumn({ title, email, password, setPassword, passwordId, authenticating, authError }) {
  return (
    <div className="demo-env-mgmt-column">
      <div className="demo-env-mgmt-title-with-label">
        <h3 className="demo-env-mgmt-column-title">{title}</h3>
        <label className="demo-env-mgmt-label">Email</label>
      </div>
      <form className="demo-env-mgmt-field" onSubmit={(e) => e.preventDefault()}>
        <div className="demo-env-mgmt-input" style={{ color: '#555', background: '#f9fafb', cursor: 'default' }}>
          {email || '—'}
        </div>

        <label className="demo-env-mgmt-label" htmlFor={passwordId} style={{ marginTop: 6 }}>Password</label>
        <div className="demo-env-mgmt-password-wrapper">
          <input
            id={passwordId}
            name="password"
            className="demo-env-mgmt-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>
      </form>

      {authenticating && <p className="demo-env-mgmt-label">Signing in…</p>}
      {authError && <p className="demo-env-mgmt-error">{authError}</p>}
    </div>
  );
}

function CredentialsSection({
  sourceEmail,
  sourcePassword,
  setSourcePassword,
  sourceAuthenticating,
  sourceAuthError,
  targetEmail,
  targetPassword,
  setTargetPassword,
  targetAuthenticating,
  targetAuthError,
}) {
  return (
    <div className="demo-env-mgmt-section">
      <h2 className="demo-env-mgmt-section-title">Contentsquare credentials</h2>
      <p className="demo-env-mgmt-label">
        Target's email comes from the Account selected in Scope above. Source's email is resolved
        from its own linked account instead — it can differ, since Source may be pre-linked across
        accounts. Each side authenticates independently. The Target login is used for
        Create/Delete/Resync; the Source login is only ever used to List.
      </p>

      <div className="demo-env-mgmt-columns">
        <CredentialsColumn
          title="Source"
          email={sourceEmail}
          password={sourcePassword}
          setPassword={setSourcePassword}
          passwordId="csq-source-password"
          authenticating={sourceAuthenticating}
          authError={sourceAuthError}
        />
        <CredentialsColumn
          title="Target"
          email={targetEmail}
          password={targetPassword}
          setPassword={setTargetPassword}
          passwordId="csq-target-password"
          authenticating={targetAuthenticating}
          authError={targetAuthError}
        />
      </div>
    </div>
  );
}

export default CredentialsSection;
